module.exports = __webpack_public_path__ + "static/media/uadvisory-illustrator.7c1af36f.svg";